import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle2, XCircle } from 'lucide-react';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [state, setState] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) { setState('error'); setMessage('Lien invalide.'); return; }
    (async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/verify-email`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.detail || 'Une erreur est survenue');
        setState('success');
        setMessage(data.message);
      } catch (err) {
        setState('error');
        setMessage(err.message);
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen bg-[#FAF9F6] flex items-center justify-center px-6">
      <div className="w-full max-w-sm text-center bg-[#FFFDF6] border border-[#F3EEE5] rounded-[24px] p-8" data-testid="verify-card">
        <h1 className="text-xl text-gray-800 mb-5" style={{ fontFamily: "'Manrope', sans-serif" }}>Spiritu’L</h1>
        {state === 'loading' && <p className="text-sm text-gray-500" data-testid="verify-loading">Confirmation en cours…</p>}
        {state === 'success' && (
          <div data-testid="verify-success">
            <CheckCircle2 size={36} className="text-[#9CCB8F] mx-auto mb-4" strokeWidth={1.6} />
            <p className="text-sm text-gray-700 mb-6">Ton adresse email est confirmée.</p>
            <Link to="/menu" className="inline-block px-8 py-3 bg-[#F79AAE] text-white text-sm rounded-full">
              Retourner à l'application
            </Link>
          </div>
        )}
        {state === 'error' && (
          <div data-testid="verify-error">
            <XCircle size={36} className="text-gray-300 mx-auto mb-4" strokeWidth={1.6} />
            <p className="text-sm text-gray-600 mb-6">{message}</p>
            <Link to="/profil" className="text-[#F79AAE] text-sm">Renvoyer un email depuis mon Profil</Link>
          </div>
        )}
      </div>
    </div>
  );
}
